import React, { useEffect, useState } from "react";
import { Card, Box, Typography } from "@mui/material";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

export default function ProgressBar(props) {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 14,
        borderRadius: '120px',
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        },
        [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: "var(--BlueBaseColor)",
        },
    }));

    const [pgbarobject, setPgbarObject] = useState({
        target: '5000.00',
        max: '8000.00',
        actual: '6000.00',
        unit: "kWh"
    });
    const [percentagevalue, setpercentagevalue] = useState('');
    const [targetposition, settargetposition] = useState('19px');
    const [consumptiontot, setconsumptiontot] = useState('0.00');
    const [targetcrossedby, settargetcrossedby] = useState('0px');

    useEffect(() => {
        var tagProperties = props.widgetprop.props.extended.tagprops;
        var currentpgbarobject = {
            target: '',
            max: '',
            actual: '',
            unit: "kWh"
        };

        tagProperties.forEach(chartType => {
            if (tagcollectionvalue.hasOwnProperty(chartType.tagid)) {
                var sum =0.0;
                var tagValues = tagcollectionvalue[chartType.tagid]
                for(let i=0;i<tagValues.length;i++){
                    sum = sum + Number(tagValues[i].y)
                }
                var datavalues = sum;
                if (chartType.isFillingSummationParameter) {
                    currentpgbarobject.actual = Number(datavalues).toFixed(2);
                } else if (chartType.isTargetSummationParameter) {
                    currentpgbarobject.target = datavalues;
                } else if (chartType.isMaxProgressBarLimit) {
                    currentpgbarobject.max = datavalues;
                }
            }
        });

        var targetval = currentpgbarobject.target;
        var max = currentpgbarobject.max;
        var left = ((targetval / max) * 620.00) + 19.00;
        var actualconsumption = currentpgbarobject.actual;
        var consumption = Number((actualconsumption / max) * 100.00).toFixed(2);
        var targetcrossedwidth = (((actualconsumption - targetval) / max) * 620.00) + 1.6;

        settargetposition(left);
        setconsumptiontot(consumption);
        setpercentagevalue(consumption);
        settargetcrossedby(targetcrossedwidth);
        setPgbarObject(currentpgbarobject);

    }, [props.widgetprop, tagcollectionvalue]);

    return (
        <Box>
            <div style={{ position: "relative" }}>
                <BorderLinearProgress
                    variant="determinate"
                    value={consumptiontot}
                    style={{ width: "620px", height: "14px", borderRadius: '0px 0px 0px 0px', backgroundColor: "var(--Searchtext_muted)", margin: "15px 20px 15px 20px" }}
                />
                <div
                    style={{ width: "2px", height: "20px", backgroundColor: "var(--RedBaseColor)", margin: "-32px 20px 20px 20px", marginLeft: targetposition, position: "absolute" }}
                ></div>
                {(pgbarobject.actual - pgbarobject.target > 0) ?
                    <div
                        style={{ width: targetcrossedby, height: "14px", backgroundColor: "var(--RedBaseColor)", margin: "-29.0px 20px 20px 20px", marginLeft: targetposition, position: "absolute" }}
                    ></div> : null}
            </div>
            <div style={{ display: 'flex', justifyContent: "space-between", width: "620px", height: "19px", paddingLeft: '0px', margin: "0px 20px 0px 20px", position: "relative", textAlign: "left" }}>
                <Typography sx={{ color: "var(--PrimaryText)", fontFamily: "Roboto", fontSize: "16px", fontWeight: 400, margin: "0px 0px 0px 0px", width: "180px" }}>
                    {pgbarobject.actual + " " + pgbarobject.unit + " " + "consumed"}
                </Typography>
                <Typography sx={{ color: "var(--PrimaryText)", fontFamily: "Roboto", fontSize: "16px", fontWeight: 400, margin: "0px 0px 0px 0px", paddingLeft: "0px", width: "220px" }}>
                    {percentagevalue + "% of consumption used"}
                </Typography>
                <Typography sx={{ color: (pgbarobject.target - pgbarobject.actual < 0) ? "var(--RedBaseColor)" : "var(--GreenBaseColor)", fontFamily: "Roboto", fontSize: "16px", fontWeight: 400, margin: "0px 0px 0px 0px", paddingLeft: "0px", textAlign: "right" }}>
                    {(pgbarobject.target - pgbarobject.actual < 0) ? "Target Exceeded" : "We are on Target"}
                </Typography>
            </div>
        </Box>
    );
}
